module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C62"
  }, [_c('em', [_c('a', {
    attrs: {
      "id": "page_VII"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_VII"
    }
  }), _c('p', {
    staticClass: "C96"
  }, [_c('a', {
    attrs: {
      "id": "page_VII"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_Never_a_City_So_Real#page_1"
    }
  }, [_vm._v("Never a City So Real")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/08_Oil_Can_Eddie#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oil Can Eddie")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/09_Millie_and_Brenda#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Millie and Brenda")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_Give_Them_What_They_Want#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Give Them What They Want")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_26th_Street#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26th Street")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/12_It_Takes_All_Kinds#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Takes All Kinds")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_Inside_Out#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inside Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_GT_s_Diner#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GT’s Diner")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/15_Isn_t_That_the_Corniche#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isn’t That the Corniche?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/16_Afterword#page_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])]), _vm._v(" "), _c('p', {
    staticClass: "C96"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_ACKNOWLEDGMENTS#page_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea150c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_Contents.vue
// module id = 69
// module chunks = 0